module.exports = __webpack_public_path__ + "static/51invgde-8d2b2d761d9922bf45fcfe98e1bc3be4.gif";